import { RoutePermissionsDto } from './models/route-permissions.dto';

/**
 * Evaluates route permissions. Legacy permissions use OR semantics; requiredPermissions
 * contains complete claims and uses AND semantics. When both are defined, both checks pass.
 */
export function hasRoutePermissions(requiredPermission: RoutePermissionsDto, userClaims: string[]): boolean {
  const hasLegacyRequirements = Boolean(requiredPermission.componentKey);
  const hasRequiredPermissions = (requiredPermission.requiredPermissions?.length ?? 0) > 0;

  if (!hasLegacyRequirements && !hasRequiredPermissions) {
    return true;
  }

  if (!userClaims || userClaims.length === 0) {
    return false;
  }

  const hasLegacyPermission =
    !hasLegacyRequirements ||
    (requiredPermission.permissions ?? []).some(permission => userClaims.includes(`${requiredPermission.componentKey}.${permission}`));
  const hasAllRequiredPermissions = (requiredPermission.requiredPermissions ?? []).every(permission => userClaims.includes(permission));

  return hasLegacyPermission && hasAllRequiredPermissions;
}
